import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { StylesProvider } from '@mui/styles';
import configureStore from "./StoreConfig";
import reportWebVitals from './reportWebVitals';
import Root from "./Components/Root.jsx";
import "react-datepicker/dist/react-datepicker.css";
import registerServiceWorker from 'react-service-worker';
const store = configureStore();

const theme = createTheme();

ReactDOM.render(
  
    <Provider store={store}>
      <Router>
        <ThemeProvider theme={theme}>
          <StylesProvider injectFirst>
            <Root />
          </StylesProvider>
        </ThemeProvider>
      </Router>
    </Provider>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
